import { Backdrop, TextField, ThemeProvider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useFormik } from "formik";
import * as yup from "yup";
// import AccessLevel from "./AccessLevel";
import { createTheme } from "@mui/material/styles";

import { toast } from "react-toastify";
import Loader from "../../../components/Loader";
import { common_axios } from "../../../App";
import Swal from "sweetalert2";

export default function UpdateAccount() {
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });
  const [open, setOpen] = useState(false);
  const [verify, setVerify] = useState("");
  const [documents, setDocuments] = useState("");
  const [user, setUser] = useState("");
  const callbackFunction = (childData) => {
    setVerify(childData);
  };
  const callbackFunction1 = (childData) => {
    setDocuments(childData);
  };
  const callbackFunction2 = (childData) => {
    setUser(childData);
  };
  const validationSchema = yup.object({
    name: yup
      .string("Enter your Name")
      .min(2, "Name should be of minimum 2 characters length")
      .required("Name is required"),

    email: yup
      .string()
      .email("E-Mail must be valid")
      .max(255)
      .required("E-Mail  is required"),
    userName: yup
      .string("Enter your userName")
      .min(2, "userName should be of minimum 2 characters length")
      .required("userName is required"),
    phoneNumber: yup
      .number("Enter your phoneNumber")
      .min(10, "phoneNumber should be of minimum 10 characters length")
      .required("phoneNumber is required"),
  });
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      userName: "",
      phoneNumber: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,
    onSubmit: async (values) => {
   
      try {
        
        setOpen(true);
        const res = await common_axios.post(`admin/v1/register/update/`, {
          username: values.userName,
          name: values.name,
          email: values.email,
          phoneNumber: values.phoneNumber,
        });

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          await setTimeout(async () => {
            // await toast.success("Updated Successfully", {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "success",
              // title: "Oops...",
              text: "Updated Successfully",
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        } else {
          setOpen(false);
          await setTimeout(async () => {
            // await toast.error(res.data.statusDescription.description, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: res.data.statusDescription.description,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
        }
      } catch (error) {
     
        setOpen(false);
        await setTimeout(async () => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    },
  });

  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>

        <ThemeProvider theme={theme}>
          <div className="container-fluid">
            <div className="card">
              <div className="card-header p-3 pt-2">
                <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 p_static position-absolute">
                  <i className="material-icons opacity-10">person</i>
                </div>
                <div className="pt-1">
                  <p
                    className="text-md text_top mb-0 text-capitalize text-start fw-bold d-inline"
                    style={{ marginLeft: "70px" }}
                  >
                    Account Updation
                  </p>
                  <p className="text-sm mb-0  text-capitalize d-inline-block float-end">
                    Field(s) marked with{" "}
                    <span className="text-danger fw-bold">*</span> are
                    mandatory.
                  </p>
                </div>
              </div>
              <div className="card-body">
                <div className="card shadow-none border bg_blue">
                  <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                    Update Account
                  </span>

                  <div className="card-body text-lg-start text-center">
                    <form
                      onSubmit={formik.handleSubmit}
                      className="row g-3 needs-validation"
                      novalidate
                    >
                      <div className="col-md-4">
                        <TextField
                          required
                          className="w-100"
                          label="Username"
                          name="userName"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={formik.values.userName}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.userName &&
                            Boolean(formik.errors.userName)
                          }
                          helperText={
                            formik.touched.userName && formik.errors.userName
                          }
                        />
                      </div>
                      <div className="col-md-4">
                        <TextField
                          required
                          className="w-100"
                          label="Name"
                          name="name"
                          variant="outlined"
                          size="small"
                          type="text"
                          value={formik.values.name}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.name && Boolean(formik.errors.name)
                          }
                          helperText={formik.touched.name && formik.errors.name}
                        />
                      </div>

                      <div className="col-md-4">
                        <TextField
                          required
                          className="w-100"
                          label="E-Mail"
                          name="email"
                          variant="outlined"
                          size="small"
                          type="email"
                          value={formik.values.email}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.email && Boolean(formik.errors.email)
                          }
                          helperText={
                            formik.touched.email && formik.errors.email
                          }
                        />
                      </div>

                      <div className="col-md-4">
                        <TextField
                          required
                          className="w-100"
                          label="Phone Number"
                          name="phoneNumber"
                          variant="outlined"
                          size="small"
                          type="number"
                          value={formik.values.phoneNumber}
                          onChange={formik.handleChange}
                          error={
                            formik.touched.phoneNumber &&
                            Boolean(formik.errors.phoneNumber)
                          }
                          helperText={
                            formik.touched.phoneNumber &&
                            formik.errors.phoneNumber
                          }
                        />
                      </div>

                      <div className="text-end ">
                    
                          <button className="btn bg-gradient-primary m-0" type="submit">
                            Submit
                            <i className="material-icons opacity-10">
                            arrow_right_alt
                          </i>
                          </button>
                          <button
                            type="button"
                            onReset={formik.handleReset}
                            className="btn bg-gradient-secondary m-0 ms-2"
                          >
                            Reset
                            <i className="material-icons opacity-10">
                            settings_backup_restore
                          </i>
                          </button>
                       
                      </div>

                      {/* <button type="button" className="btn btn-primary">
              Save
            </button> */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ThemeProvider>
      </main>
    </>
  );
}
